import React from 'react';
import { Card, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './organizerProfile.scss';

export default function LegalRepresentative({ formOrganisation, onChange, organisationErrors }) {
    const { t } = useTranslation();
    return (
        <Card.FormStep className="organizer-formstep-form" title={t(`ticket.organiser.legal_representative.title`)} rightComponent id="organiser-form-legal_representative">
            <>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.legal_representative.last_name')} required />
                    <Form.Input
                        errors={!!organisationErrors['last_name']}
                        maxLength={80}
                        name="last_name"
                        value={formOrganisation.last_name}
                        onChange={({ target: { value } }) => {
                            onChange('last_name', value);
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['last_name'] ? [t(organisationErrors['last_name'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.legal_representative.first_name')} required />
                    <Form.Input
                        errors={!!organisationErrors['first_name']}
                        maxLength={80}
                        name="first_name"
                        value={formOrganisation.first_name}
                        onChange={({ target: { value } }) => {
                            onChange('first_name', value);
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['first_name'] ? [t(organisationErrors['first_name'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.legal_representative.position')} />
                    <Form.Input
                        maxLength={80}
                        name="position"
                        value={formOrganisation.position}
                        placeholder={t('ticket.organiser.legal_representative.placeholder_position')}
                        onChange={({ target: { value } }) => {
                            onChange('position', value);
                        }}
                    />
                </Form.Field>
            </>
        </Card.FormStep>
    );
}
LegalRepresentative.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
